import React from 'react'
import './OpticalsTypes.css'

function OpticalsTypes() {
    return (
        <div className='opticals_type'>
            <div className='row1'>
                <div className='optical'>
                    <img src='https://cdn.eyemyeye.com/mobile/images/Home/top_cat/eyeglasses.svg' alt='eyeglass' />
                    <p className='optical_name'>Eyeglasses</p>
                </div>
                <div className='optical'>
                    <img src='https://cdn.eyemyeye.com/mobile/images/Home/top_cat/sunglasses.svg' alt='eyeglass' />
                    <p className='optical_name'>Sunglasses</p>
                </div>
                <div className='optical'>
                    <img src='https://cdn.eyemyeye.com/mobile/images/Home/top_cat/computer-glasses.svg' alt='eyeglass' />
                    <p className='optical_name'>Computer glasses</p>
                </div>
            </div>
            <div className='row1 row2'>
                <div className='optical'>
                    <img src='https://cdn.eyemyeye.com/mobile/images/Home/top_cat/luxe_icon.svg' alt='eyeglass' />
                    <p className='optical_name'>EME Luxe</p>
                </div>
                <div className='optical'>
                    <img src='https://cdn.eyemyeye.com/mobile/images/Home/top_cat/kids-eye.svg' alt='eyeglass' />
                    <p className='optical_name'>Kids Glasses</p>
                </div>
                <div className='optical'>
                    <img src='https://cdn.eyemyeye.com/mobile/images/Home/top_cat/power-eye.svg' alt='eyeglass' />
                    <p className='optical_name'>Power Sunglasses</p>
                </div>
            </div>
        </div>
    )
}

export default OpticalsTypes